// The contract for persisting annotations. UI/features depend on this interface
// only — never on a concrete transport. The v1 adapter talks to the REST
// /annotations endpoints; a DICOM SR/ANN export adapter can slot in later, and
// because this is independent of DataSource it may even live at a different
// origin (annotations composed into a study by its public id).

import type { Annotation, AnnotationPatch, NewAnnotation } from './types';

export interface AnnotationStore {
  /** All annotations for a study, by public id (optionally narrowed to one series, by UID). */
  list(studyId: string, seriesInstanceUID?: string): Promise<Annotation[]>;
  create(annotation: NewAnnotation): Promise<Annotation>;
  update(id: string, patch: AnnotationPatch): Promise<Annotation>;
  remove(id: string): Promise<void>;
}

/**
 * A write the server refused, with its own sentence ("you can view this slide
 * but not annotate it") and status, so the viewer can say why a shape it
 * already drew has gone again — and a 403 can switch the tools off.
 *
 * `code` tells two 403s apart: `not_author` is one annotation that is somebody
 * else's, which says nothing about the slide's other tools.
 */
export class AnnotationWriteError extends Error {
  constructor(message: string, readonly status: number, readonly code?: string) {
    super(message);
  }
}
